module.exports = __webpack_public_path__ + "img/Artboard_1@2x.afc4b008.png";